class StSelectController {
    constructor($translate) {
        'ngInject';
        // TODO: tranlations
        this.$translate = $translate;
        this.name = 'stSelect';
        // this.transfersTableService = transfersTableService;
        this.dropText = this.$translate.instant(this.items[0].name);
    }

    toggleDropdown(item) {
        this.getTransfers({
            gateway: item.id
        });
        this.dropText = this.$translate.instant(item.name);
    }
}

export default StSelectController;


// WEBPACK FOOTER //
// ./client/app/common/stSelect/stSelect.controller.js